export const EMPTY_VALUE = '—'

export function formatInteger(value) {
  if (value == null || Number.isNaN(Number(value)) || Number(value) === 0) {
    return EMPTY_VALUE
  }

  return Number(value).toLocaleString()
}
